export default __webpack_public_path__ + "static/media/btn-right-off@3x.f4ccb6e2.png";